import { render, staticRenderFns } from "./CrudFormStep.vue?vue&type=template&id=54fea094&lang=pug&"
import script from "./CrudFormStep.vue?vue&type=script&lang=js&"
export * from "./CrudFormStep.vue?vue&type=script&lang=js&"
import style0 from "./CrudFormStep.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CrudFormStep.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VFlex,
  VIcon,
})
